import { IEvent, IEventData, IEventsProvider } from '../events/types';
import { TAuthUser } from '../../spa/store/general/types';
import { addonInit, addonSetAccount, addonSetUserId, addonTrack } from './addonClient';

// Дублирует все события EventsRouter в наш проект Amplitude (переходный период).
// В Amplitude — только hashId и хэш email (lm_account); сам email, имя и googleId не уходят.
export class AddonEventsProvider implements IEventsProvider {

  // Провайдер создаётся при загрузке EventsRouter — это самый ранний момент запуска.
  // Раньше экземпляр поднимался по первому событию, и у анонимного посетителя не поднимался вовсе.
  constructor() {
    addonInit();
  }

  setUser(user: TAuthUser): void {
    try {
      addonSetUserId(user.hashId);
    } catch (e) { /* noop */ }
    try {
      addonSetAccount(user.email);
    } catch (e) { /* noop */ }
  }

  trackEvent(event: IEvent, date: Date, data: IEventData): void {
    try {
      const { userId, ...rest } = data as Record<string, any>;
      if (userId) addonSetUserId(String(userId));
      addonTrack(event.subject + ': ' + event.action, rest, date.getTime());
    } catch (e) { /* noop */ }
  }
}
